<template>
  <div class="dropdown" :style="cssVars">
    <a-dropdown @visibleChange="onVisibleChange" :trigger="['click']">
      <div class="dropdown-trigger">
        <img class="dropdown-icon tenant-icon" src="../../assets/images/tenant.png" alt="tenant" />
        <a class="name"  @click.prevent>{{merchantName}}
          <img class="arrows" width="18px"  src="../../assets/images/downOut.png" v-if="merchantOptions.length > 1"/>
        </a>
      </div>
      <div slot="overlay" class="tenant-switch-overlay">
        <div class="tenant-switch-search" @mousedown.stop @click.stop>
          <a-input
            v-model="merchantKeyword"
            size="small"
            allowClear
            placeholder="可输入租户名称搜索"
            @keydown.stop
            @keyup.stop
          >
        <template slot="prefix">
          <a-icon type="search" />
        </template>
        </a-input>
        </div>
        <div class="tenant-switch-menuList">
          <a-menu>
            <a-menu-item v-for="item in filteredMerchantOptions" :key="item.customerId" :value="item.customerId">
              <div @click="switchTenant(item)">{{item.tenantName}}</div>
            </a-menu-item>
            <a-menu-item v-if="filteredMerchantOptions.length === 0" key="__empty" disabled>
              <span class="tenant-switch-empty">无匹配结果</span>
            </a-menu-item>
          </a-menu>
        </div>
      </div>
    </a-dropdown>
  </div>
</template>
<script>
import { post } from '@/utils/http';
import api from '@/api';
import { message } from 'ant-design-vue';
import { getUiFitment } from '@/utils/accessResources';
import mainBus from '@/micro/eventBus';
import { getLogo } from '@/utils/intConfiguration';
import {
  setAccount, setToken,
} from '../../views/login/login-handler';

export default {
  name: 'TenantSwitch',
  created() {
    this.getTenantList();
  },
  data() {
    return {
      logoUi: getLogo(),
      merchantName: '',
      merchantOptions: [],
      merchantKeyword: '',
      switchLoading: null,
    };
  },
  computed: {
    filteredMerchantOptions() {
      const keyword = String(this.merchantKeyword || '').trim().toLowerCase();
      if (!keyword) return this.merchantOptions;
      return (this.merchantOptions || []).filter((item) => {
        const tenantName = String(item.tenantName || '').toLowerCase();
        const customerId = String(item.customerId || '').toLowerCase();
        return tenantName.includes(keyword) || customerId.includes(keyword);
      });
    },
    cssVars() {
      return {
        '--navigationBackColor': this.logoUi.navigationBackColor,
        '--themeColor': this.logoUi.themeColor,
        '--navigationFoldColor': this.logoUi.navigationFoldColor,
      };
    },
  },
  mounted() {
    mainBus.$on('systemInterface', () => {
      // eslint-disable-next-line no-unused-expressions
      // this.switchTenant()
      this.merchantOptions.forEach((m) => {
        if (m.tenantName === this.merchantName) {
          this.switchTenant(m);
        }
      });
    });
  },
  methods: {
    onVisibleChange(visible) {
      if (!visible) this.merchantKeyword = '';
    },
    getTenantList() {
      const appId = localStorage.getItem('appId') || '';
      const userInfo = localStorage.getItem('user_info') || '{}';
      const info = JSON.parse(userInfo);
      this.merchantName = info.tenantName;
      post(api.tenantList, { appId, userId: info.passportId }).then((res) => {
        this.merchantOptions = res;
      });
    },
    switchTenant(val) {
      this.switchLoading = message.open({
        duration: 0,
        icon: <a-icon type="loading" style="color: #4d4dff;" />,
        content: '租户切换中，请稍候...',
      });
      post(api.switchTenant, { customerId: val.customerId })
        .then((res) => {
          setToken(res);
          this.getLoginAccount(res);
        })
        .catch(() => {
          message.error('租户切换失败，请稍后重试');
          if (typeof this.switchLoading === 'function') {
            this.switchLoading();
          }
        });
    },
    // 获取用户信息
    getLoginAccount(loginRes) {
      post(api.loginAccount, {}).catch(() => {
        message.error('用户信息查询失败');
        if (typeof this.switchLoading === 'function') {
          this.switchLoading();
        }
      })
        .then((res) => {
          // 之后缓存菜单需要参数
          setAccount(res, loginRes);
          getUiFitment().finally(() => {
            if (typeof this.switchLoading === 'function') {
              this.switchLoading();
            }
            if (res.id) {
              this.$store.commit('emptyTab');
              setTimeout(() => {
                this.$router.push('/');
                // eslint-disable-next-line no-restricted-globals
                location.reload();
              }, 1000);
            }
          });
        });
    },
  },
};
</script>

<style lang="less" scoped>

.dropdown{
  padding-left: 16px;
  .dropdown-trigger{
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .dropdown-icon{
    margin-right: 4px;
    vertical-align: middle;
    padding-bottom: 13px;
  }
  .tenant-icon{
    width: 20px;
  }
  .name{
    font-size: 14px;
    padding-bottom: 8px;
    color: #666666;
  }
  .arrows{
    margin-left: 8px;
    padding-bottom: 5px;
  }
}

.tenant-switch-overlay{
  width: 240px;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
}

.tenant-switch-search{
  padding: 6px 8px;

  /deep/ .ant-input {
    &:focus {
      border-color: var(--themeColor) !important;
      box-shadow: none;
    }

    &:hover {
      border-color: var(--themeColor) !important;
      box-shadow: none;
    }
  }

  /deep/ .ant-input-affix-wrapper .ant-input:not(.ant-input-disabled) {
    height: 30px;
  }

  /deep/ .ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {
    border-color: var(--themeColor) !important;
  }
}

.tenant-switch-menuList{
  max-height: 60vh;
  overflow-y: auto;

  /deep/ .ant-menu.ant-menu-vertical {
    border-right: none;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  /deep/ .ant-menu-item {
    line-height: 22px;
    height: auto;
    font-size: 14px;
    padding: 5px 12px;

    &:hover {
      color: rgba(0, 0, 0, 0.65);
      background-color: #EEEEFF;
    }
    &:not(:last-child) {
      margin-bottom: 0;
    }
  }
}

.tenant-switch-empty{
  color: #999;
}
</style>
